import { render, staticRenderFns } from "./videoPopover.vue?vue&type=template&id=0d516a42&scoped=true&"
import script from "./videoPopover.vue?vue&type=script&lang=js&"
export * from "./videoPopover.vue?vue&type=script&lang=js&"
import style0 from "./videoPopover.vue?vue&type=style&index=0&id=0d516a42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d516a42",
  null
  
)

export default component.exports